import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles(() => ({
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    justifyContent: 'space-between',
    width: '100%',
    overflowY: 'auto',
  },

  root: {
    borderRadius: '1rem',
    width: '100%',
    height: '70vh',
    backgroundColor: '#fff',
    padding: '0.25rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  page: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    maxWidth: contentMaxWidth,
    paddingY: '1.25rem',
    paddingX: '0',
    marginTop: '1rem',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',

    '& h1': {
      margin: 0,
      padding: 0,
      marginTop: '1rem',
      fontFamily: 'Sora',
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: '1.75rem',
    },

    '& p': {
      margin: 0,
      padding: 0,
      fontFamily: 'Nunito',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
      color: getRGBA('#0F0F1E', 0.6),
    },
  },
}))

export { useStyles }
